<template>
  <div class="page">
    <header>
      <Header />
    </header>
    <main class="content">
      <!-- 侧边 -->
      <aside v-if="$route.path.includes('/system')" ref="aside">
        <Aside :side-list="leftNav" />
      </aside>
      <router-view class="main_content" />
    </main>
  </div>
</template>

<script>
import Header from './components/header'
import Aside from './components/aside'

export default {
  name: 'DataScreen',
  components: {
    Header,
    Aside,
  },
  data () {
    return {
      // 使用侧边栏的页面
      leftNav: [
        {
          name: '系统管理',
          path: '/system',
          icon: 'zu33680',
          children: [
            { name: '基础设置', path: '/system/basicSetting', icon: 'zu33681' },
            { name: '人员管理', path: '/system/personnelManage', icon: 'zu33682' },
            { name: '数据更新日志', path: '/system/dataUpdatedLog', icon: 'zu33683' },
            { name: '系统维护日志', path: '/system/systemPreserveLog', icon: 'zu33684' },
            { name: '操作日志', path: '/system/operationLog', icon: 'zu33685' },
          ],
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.page {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-size: cover;
  .content {
    flex: 1;
    position: relative;
    display: flex;
    height: 0;
    .main_content{
      height: 100%;
      width: 100%;
    }
  }
}
</style>
